/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";

import { ActionModel } from "../../Common/ActionModel";
import { Panel } from "../../../../ui/components/Panel";
import { BEM, T, useTranslate } from "@adapptio/lib-components";
import { ToolbarCommandButton } from "../../../../ui/components/Toolbar/ToolbarCommandButton";
import { termsEditorActionEditor } from "../../../../terms/actionEditor";
import { Inspector } from "../../../../inspector";

export interface IActionEditorSettingsProps {
	model: ActionModel;
}

export const ActionEditorSettings: React.FunctionComponent<IActionEditorSettingsProps> = ({ model }) => {
	const t = useTranslate();

	const specModel = model.getModel().props.spec;

	const baseClass = BEM("edt-inspect-panel");

	return (
		<Panel scroll={true}>
			<div className={baseClass.toClassName()}>
				<div className={baseClass.element("header").toClassName()}>
					<div className={baseClass.element("header-info").toClassName()}>
						<span className={baseClass.element("header-info-name").toClassName()}>
							<T domain="editor" term={termsEditorActionEditor.actionSettings.label} />
						</span>
					</div>
				</div>
				<div className={baseClass.element("content").toClassName()}>
					<Inspector label="Settings" group>
						<Inspector model={specModel.props.requireAuthenticatedUser} />
						<Inspector model={specModel.props.timeout} />
						<Inspector model={specModel.props.maxRecursion} />
						<Inspector model={specModel.props.scheduled} />
						<Inspector model={specModel.props.private} />
					</Inspector>
				</div>
			</div>
		</Panel>
	);
};
